<div class="pos-relative">
    <ng-content></ng-content>
    <div class="pos-absolute z-1 bottom-0 top-0 flex flex-middle right-5 toggle-password">
        <span class="cursor-pointer s2"
              (click)="toggle()">{{isPasswordType ? 'Show' : 'Hide'}}</span>
    </div>
</div>